import { _ as e } from "../../_rollupPluginBabelHelpers-d2f9cf82.js";
import s, { useContext as t } from "react";
import i from "../../contexts/state-context.js";
import r from "../Widgets/RichFieldCustomHTML/RichFieldCustomHTML.js";
import o from "../Widgets/RichFieldBulletPointList/RichFieldBulletPointList.js";
import "../../RichFieldBulletPointImageList-0d3ffab7.js";
import c from "../Widgets/RichFieldImageList/RichFieldImageList.js";
import n from "../Widgets/RichFieldNewsfeed/RichFieldNewsfeed.js";
import a from "../Widgets/RichFieldBannerImage/RichFieldBannerImage.js";
import "../../style-inject.es-1f59c1d0.js";
import "../IconsMapper/IconsMapper.js";
import "@fortawesome/react-fontawesome";
import "@fortawesome/free-solid-svg-icons";
import "../../services/Images.js";
import "../../services/Tracking/Tracking.js";
import "../../services/Tracking/FacebookPixel.js";
import "../../services/Tracking/Pl.js";
import "../../services/ApiRequests.js";
import "axios";
import "../../services/Tracking/GoogleAnalitycs.js";
import "../../services/Utils.js";
import "../../services/Tracking/GoogleTagManager.js";
import "../../services/Url.js";
import "../Widgets/BasicButton/BasicButton.js";
import "../Widgets/Spinner/Spinner.js";
import "../../swiper.min-fcb62bfb.js";
var l = function (l) {
  var m,
    p = l.groupId,
    d = l.style,
    f = void 0 === d ? {} : d,
    u = l.classes,
    g = void 0 === u ? {} : u,
    E = l.tracking,
    I = void 0 === E ? {} : E,
    T = t(i),
    j = e(T, 1)[0];
  m = p ? j.lp.rich_fields.filter(function (e) {
    return e.group === p;
  }) : j.lp.rich_fields, function () {
    try {
      m = m.sort(function (e, s) {
        return parseInt(e.order) < parseInt(s.order) ? -1 : 1;
      });
    } catch (e) {
      console.log(e);
    }
  }();
  var L = function (e) {
    var t = e.section;
    switch (t.fields = t.fields.sort(function (e, s) {
      return parseInt(e.order) < parseInt(s.order) ? -1 : 1;
    }), t.view_kind) {
      case "CUSTOM_HTML":
        return s.createElement(r, {
          section: t,
          style: f.CUSTOM_HTML,
          classes: g.CUSTOM_HTML
        });
      case "BULLET_POINT_LIST":
        return s.createElement(o, {
          section: t,
          style: f.BULLET_POINT_LIST,
          classes: g.BULLET_POINT_LIST
        });
      case "IMAGE_LIST":
        return s.createElement(c, {
          section: t,
          style: f.IMAGE_LIST,
          classes: g.IMAGE_LIST,
          tracking: I.IMAGE_LIST
        });
      case "NEWSFEED":
        return s.createElement(n, {
          section: t,
          style: f.NEWSFEED,
          classes: g.NEWSFEED
        });
      case "IMAGE_BANNER":
        return s.createElement(a, {
          section: t,
          style: f.IMAGE_BANNER,
          classes: g.IMAGE_BANNER,
          tracking: I.IMAGE_BANNER
        });
      default:
        return s.createElement(s.Fragment, null);
    }
  };
  return m.map(function (e, t) {
    return s.createElement(L, {
      section: e,
      key: t
    });
  });
};
export { l as default };